import $ from "jquery";
import {addActiveBackdrop} from "../modal-backdrop";
import {renderModal} from "../render-modal";

export const bindEventsToProfileChangePasswordModalCallingBtn = () => {
    $('#change-password-button').on("click", function (e) {
        addActiveBackdrop();
        renderModal($(this).data('url'), '#change-password');
    });
};
